import { Component } from '@angular/core';

import { NavController, LoadingController } from 'ionic-angular';

import { LoginPage } from '../login/login';
import { ConfirmPage } from '../confirm/confirm';

import { User } from '../../providers/user';

export class UserVerify{
    currentPw:string;
    newPw:string;
    confirmNewPw:string;
}

@Component({
  selector: 'page-change-pw',
  templateUrl: 'change-pw.html'
})
export class ChangePwPage {

  public userVerify: UserVerify;
  
  error: any;
  public errorMessage:string = "";

  constructor(public navCtrl: NavController,
              public user: User,
              public loadingCtrl: LoadingController) {
    this.userVerify = new UserVerify();
  }

  resetpw() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.error = null;
    console.log('changepw');
    loading.dismiss();
  }

  savePw(){
      this.errorMessage ="";

      if(this.userVerify.confirmNewPw !== this.userVerify.newPw){
          this.errorMessage = "Password and confirmation passwords do not match!";
          return;
      }
      else
      {
          this.user.changePassword(this.userVerify.currentPw,this.userVerify.newPw)          
          .catch((err)=>{
              this.errorMessage = err.message;
          })
          .then((res)=>{
              if(res){
                this.errorMessage = "";
                alert("Password Changed Sucessfully!");
                this.back();
            }
          });
      }

  }

  back() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-pw/change-pw.ts